import React, { ReactElement } from 'react';
import styled from 'styled-components/macro';
import Breakpoints from 'themes/constants/breakpoints';

// Styles
const Wrap = styled.h2`
  font-size: 28px;
  line-height: 1;
  color: ${({ theme, color }) => color || theme.color.primary};
  font-weight: 500;
  text-align: start;
  letter-spacing: -0.01px;
  @media only screen and (${Breakpoints.TABLET}) {
    font-size: 32px;
  }
  @media only screen and (${Breakpoints.LAPTOP}) {
    text-align: left;
    font-size: 36px;
  }
`;

// Interfaces
type IChild = string | ReactElement | null;
interface ITitle {
  className?: string
  color?: string
  children: IChild | IChild[];
  onClick?: () => void
}

// Component
const Title = (props: ITitle) => {
  const {
    className,
    color,
    children,
    onClick,
  } = props;

  return (
    <Wrap onClick={onClick} className={className} color={color}>{children}</Wrap>
  );
};

Title.defaultProps = {
  className: '',
  color: '',
  onClick: () => {},
};

export default Title;
